export const DEFAULT_ROLLBAR_SCRUB_FIELDS = [
    'password',
    'token',
    'secret',
    'authorization',
    'cookie',
    'csrf_token',
    'access_token',
    'refresh_token',
    'session',
    'session_id',
] as const;
